<template>
  <div class="product-page">
    <el-card shadow="never" class="product-card">
      <template #header>
        <div class="page-header">
          <div>
            <div class="page-title">产品维护</div>
            <div class="page-subtitle">维护小程序产品分类、图标名称、售价、内部价、第三方厂商、报告样例和状态</div>
          </div>
          <el-button type="primary" @click="openDialog()">新增产品</el-button>
        </div>
      </template>

      <el-form :model="search" label-width="72px" class="search-form">
        <el-row :gutter="12">
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="分类">
              <el-input v-model="search.name" clearable placeholder="例如：出险" @keyup.enter="loadData" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="产品">
              <el-input v-model="search.description" clearable placeholder="例如：车信盟出险" @keyup.enter="loadData" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="厂商">
              <el-select v-model="search.thirdPartyName" clearable filterable placeholder="全部厂商" style="width: 100%" @change="loadData">
                <el-option v-for="item in vendorOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="状态">
              <el-select v-model="search.status" clearable placeholder="全部" style="width: 100%">
                <el-option label="启用" :value="1" />
                <el-option label="停用" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="search-actions">
          <el-button type="primary" @click="loadData">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
      </el-form>

      <el-table :data="products" border stripe v-loading="loading" height="calc(100vh - 340px)">
        <el-table-column prop="productId" label="ID" width="170" show-overflow-tooltip />
        <el-table-column prop="name" label="分类" min-width="110" show-overflow-tooltip />
        <el-table-column prop="description" label="产品名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="iconDisplayName" label="图标名称" min-width="110" show-overflow-tooltip />
        <el-table-column label="第三方厂商" min-width="160" show-overflow-tooltip>
          <template #default="scope">
            <span>{{ getVendorDisplay(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="售价" width="100" align="right">
          <template #default="scope">{{ formatPrice(scope.row.price) }}</template>
        </el-table-column>
        <el-table-column label="内部价" width="100" align="right">
          <template #default="scope">{{ formatPrice(scope.row.discountAmt) }}</template>
        </el-table-column>
        <el-table-column label="报告样例" min-width="160" show-overflow-tooltip>
          <template #default="scope">
            <el-link v-if="scope.row.reportSampleUrl" type="primary" :href="scope.row.reportSampleUrl" target="_blank">
              查看样例
            </el-link>
            <span v-else class="muted">未配置</span>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="90" align="center" />
        <el-table-column label="状态" width="90" align="center">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updatedTime" label="更新时间" min-width="170" show-overflow-tooltip />
        <el-table-column fixed="right" label="操作" width="230">
          <template #default="scope">
            <el-button size="small" @click="openDialog(scope.row)">编辑</el-button>
            <el-button size="small" :type="scope.row.status === 1 ? 'warning' : 'success'" @click="toggleStatus(scope.row)">
              {{ scope.row.status === 1 ? '停用' : '启用' }}
            </el-button>
            <el-button size="small" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-box">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          v-model:current-page="page.current"
          v-model:page-size="page.size"
          :total="page.total"
          :page-sizes="[20, 50, 100]"
          @current-change="loadData"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <el-dialog v-model="dialog.visible" :title="dialog.form.productId ? '编辑产品' : '新增产品'" width="720px">
      <el-form :model="dialog.form" label-width="112px">
        <el-form-item label="分类名称" required>
          <el-input v-model="dialog.form.name" placeholder="例如：出险 / 维保 / 电池健康 / 云端调表" />
        </el-form-item>
        <el-form-item label="产品名称" required>
          <el-input v-model="dialog.form.description" placeholder="例如：车信盟出险" />
        </el-form-item>
        <el-form-item label="图标名称">
          <el-input v-model="dialog.form.iconDisplayName" placeholder="小程序首页图标内显示的名称" />
        </el-form-item>
        <el-form-item label="第三方厂商" required>
          <el-select v-model="dialog.form.thirdPartyName" filterable clearable placeholder="请选择第三方厂商" style="width: 100%">
            <el-option v-for="item in vendorOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="售价">
          <el-input-number v-model="dialog.form.priceYuan" :precision="2" :min="0" :controls="false" style="width: 100%" />
        </el-form-item>
        <el-form-item label="内部价">
          <el-input-number v-model="dialog.form.discountYuan" :precision="2" :min="0" :controls="false" style="width: 100%" />
        </el-form-item>
        <el-form-item label="报告样例">
          <div class="sample-box">
            <div class="sample-actions">
              <el-input v-model="dialog.form.reportSampleUrl" clearable placeholder="填写报告样例在线地址，例如 MinIO HTML 或图片地址" />
              <el-button v-if="dialog.form.reportSampleUrl" @click="previewReportSample">预览</el-button>
              <el-button v-if="dialog.form.reportSampleUrl" type="danger" plain @click="clearReportSample">清除</el-button>
            </div>
            <div v-if="dialog.form.reportSampleUrl" class="sample-result">
              <el-link :href="dialog.form.reportSampleUrl" target="_blank" type="primary">{{ dialog.form.reportSampleUrl }}</el-link>
            </div>
            <div v-else class="sample-tip">直接填写可公开访问的线上地址，避免浏览器另存 HTML 后丢失静态资源。</div>
          </div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="dialog.form.sortOrder" :min="0" :controls="false" style="width: 100%" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="dialog.form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { deleteProductFun, getDictOptionsFun, getProductListFun, saveProductFun, updateProductStatusFun } from "@/api/product";

const THIRD_PARTY_VENDOR = "THIRD_PARTY_VENDOR";
const loading = ref(false);
const saving = ref(false);
const products = ref([]);
const vendorOptions = ref([]);
const search = reactive({ name: "", description: "", thirdPartyName: "", status: "" });
const page = reactive({ current: 1, size: 20, total: 0 });
const dialog = reactive({ visible: false, form: {} });
const DEFAULT_VENDOR_OPTIONS = [
  { value: "CXM", label: "车信盟" },
  { value: "CHENGHAO", label: "诚浩" },
  { value: "SANCAI", label: "三才" },
  { value: "SANCAI_BRIEF", label: "三才底档" },
  { value: "XYL", label: "柠檬查" },
  { value: "PLUS", label: "车况Plus" },
  { value: "CXM_NON_DAMAGE", label: "车信盟非车损" },
  { value: "JINGYOU", label: "精友" },
  { value: "WENZHU", label: "文竹" },
  { value: "WENZHU_OBD", label: "文竹OBD" },
  { value: "MILEAGE_CHAIN", label: "里程链" },
  { value: "QXB_NORMAL", label: "汽修宝普通版" },
  { value: "QXB_PRECISE", label: "汽修宝精准版" },
  { value: "YAXIN_NEW_ENERGY", label: "亚信新能源" },
];

function formatPrice(price) {
  return `￥${((Number(price) || 0) / 100).toFixed(2)}`;
}

function toCent(value) {
  return Math.round((Number(value) || 0) * 100);
}

function getVendorDisplay(row = {}) {
  const code = normalizeVendorCode(row.thirdPartyName);
  const name = row.thirdPartyDisplayName || getVendorLabel(code) || code || "--";
  return code ? `${name}（${code}）` : name;
}

function getVendorLabel(code) {
  const value = normalizeVendorCode(code);
  return vendorOptions.value.find((item) => item.value === value)?.label || "";
}

function normalizeVendorCode(code) {
  const value = String(code || "").trim().toUpperCase();
  if (value === "HINGYOU" || value === "HANGYOU") return "JINGYOU";
  return value;
}

function mergeVendorOptions(options = []) {
  const map = new Map();
  DEFAULT_VENDOR_OPTIONS.forEach((item) => map.set(item.value, item));
  options.forEach((item) => {
    const value = normalizeVendorCode(item.value || item.itemCode || item.code);
    const label = item.label || item.itemName || item.name || value;
    if (value) map.set(value, { value, label });
  });
  return Array.from(map.values());
}

function loadVendorOptions() {
  return getDictOptionsFun(THIRD_PARTY_VENDOR).then((res) => {
    vendorOptions.value = mergeVendorOptions(res.data || []);
  }).catch(() => {
    vendorOptions.value = mergeVendorOptions();
  });
}

function loadData() {
  loading.value = true;
  getProductListFun({ ...search, current: page.current, size: page.size })
    .then((res) => {
      products.value = res.data?.records || [];
      page.total = res.data?.total || 0;
    })
    .finally(() => {
      loading.value = false;
    });
}

function resetSearch() {
  search.name = "";
  search.description = "";
  search.thirdPartyName = "";
  search.status = "";
  page.current = 1;
  loadData();
}

function handleSizeChange() {
  page.current = 1;
  loadData();
}

function openDialog(row) {
  dialog.form = row
    ? {
        productId: row.productId,
        name: row.name || "",
        description: row.description || "",
        iconDisplayName: row.iconDisplayName || "",
        thirdPartyName: normalizeVendorCode(row.thirdPartyName),
        priceYuan: (row.price || 0) / 100,
        discountYuan: (row.discountAmt || 0) / 100,
        reportSampleUrl: row.reportSampleUrl || "",
        sortOrder: row.sortOrder ?? 0,
        status: row.status ?? 1,
      }
    : { name: "", description: "", iconDisplayName: "", thirdPartyName: "", priceYuan: 0, discountYuan: 0, reportSampleUrl: "", sortOrder: 0, status: 1 };
  dialog.visible = true;
}

function previewReportSample() {
  if (dialog.form.reportSampleUrl) window.open(dialog.form.reportSampleUrl, "_blank");
}

function clearReportSample() {
  dialog.form.reportSampleUrl = "";
}

function save() {
  if (!dialog.form.name || !dialog.form.description) {
    ElMessage.warning("请填写分类名称和产品名称");
    return;
  }
  if (!dialog.form.thirdPartyName) {
    ElMessage.warning("请选择第三方厂商");
    return;
  }
  const data = {
    productId: dialog.form.productId,
    name: dialog.form.name,
    description: dialog.form.description,
    iconDisplayName: dialog.form.iconDisplayName,
    thirdPartyName: normalizeVendorCode(dialog.form.thirdPartyName),
    price: toCent(dialog.form.priceYuan),
    discountAmt: toCent(dialog.form.discountYuan),
    reportSampleUrl: dialog.form.reportSampleUrl,
    sortOrder: dialog.form.sortOrder,
    status: dialog.form.status,
  };
  saving.value = true;
  saveProductFun(data)
    .then(() => {
      ElMessage.success("保存成功");
      dialog.visible = false;
      loadData();
    })
    .finally(() => {
      saving.value = false;
    });
}

function toggleStatus(row) {
  const status = row.status === 1 ? 0 : 1;
  updateProductStatusFun(row.productId, status).then(() => {
    ElMessage.success(status === 1 ? "已启用" : "已停用");
    loadData();
  });
}

function remove(row) {
  const name = row.description || row.name || row.productId;
  ElMessageBox.confirm(`确认删除产品“${name}”吗？`, "提示", { type: "warning" })
    .then(() => deleteProductFun(row.productId))
    .then(() => {
      ElMessage.success("删除成功");
      loadData();
    });
}

onMounted(() => {
  loadVendorOptions().finally(loadData);
});
</script>

<style scoped lang="scss">
.product-page { padding: 16px; }
.product-card { border-radius: 6px; }
.page-header { display: flex; align-items: center; justify-content: space-between; }
.page-title { font-size: 18px; font-weight: 600; color: #1f2937; }
.page-subtitle { margin-top: 4px; font-size: 12px; color: #8a94a6; }
.search-form { margin-bottom: 12px; }
.search-actions { display: flex; justify-content: flex-end; gap: 8px; }
.pagination-box { display: flex; justify-content: flex-end; padding-top: 12px; }
.muted { color: #9ca3af; }
.sample-box { width: 100%; }
.sample-actions { display: flex; align-items: center; gap: 8px; }
.sample-result { display: flex; align-items: center; gap: 8px; margin-top: 8px; min-width: 0; }
.sample-result .el-link { max-width: 520px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sample-tip { margin-top: 8px; color: #8a94a6; font-size: 12px; }
</style>
